import cloneDeep from 'clone-deep'

import type { Flow, ResetUserDataOptions } from '../api/models/types'

export default function resetUserData(oldData: object, form: Flow, options?: ResetUserDataOptions) {
  //* Clone provided userData object
  const userData = cloneDeep(oldData)

  //* Extract keys that should be preserved CFs, experiments, and connected experiments
  const computedFieldKeys = ((form && form.computedFields) || []).map((cf) => cf.key)
  const experimentKeys = ((form && form.experiments) || []).map((e) => e.key)
  const connectedExperiments = ((form && form.connected_experiments) || []).map(
    (ce) => ce.experiment_key
  )

  //* List also custom keys to preserve
  const allowedKeys = new Set([
    'entryId',
    'is_test',
    '_referrer',
    '_has_analytics',
    'location_data',
    '_source_data',
    'first_version',
    'last_version',
    'current_total_pages',
    'highest_page_reached_index',
    'highest_page_reached_id',
    'highest_page_reached_key',
  ])

  if (options?.preserveCurrentPage) {
    allowedKeys.add('current_page_id')
    allowedKeys.add('current_page_key')
    allowedKeys.add('current_page_index')
  }

  //* Remove keys that should not be preserved
  Object.keys(userData).forEach((key) => {
    if (
      !allowedKeys.has(key) &&
      !computedFieldKeys.includes(key) &&
      !experimentKeys.includes(key) &&
      !connectedExperiments.includes(key)
    )
      delete userData[key]
  })

  //* Add default values to the userData object
  if (form && form.defaults && form.defaults.userData) {
    Object.entries(form.defaults.userData || {}).forEach(([k, v]) => {
      if (!allowedKeys.has(k)) userData[k] = v
    })
  }

  return userData
}
